import { object, string } from "yup";

const validationSchema = object().shape({
  name: string().required("You must enter a name"),
  comments: string().required("You must enter a message"),
});

export default () => validationSchema;
